/**
 * Los logos, fondos y texto de la marca activa (SL-1920).
 *
 * Reemplaza a `hooks/useTheme` y `assets/img/themeLogos`, que leían la marca de
 * `<html>` (`--ant-appName`, siempre "Silia") y nunca veían la del deploy.
 * Esto lee el contexto de `BrandProvider`: ninguna lectura del DOM.
 */

import { useBrand } from './BrandProvider';
import { TEMPLATES } from './brands/registry';
import { BRAND_META, type BrandMeta } from './brands/meta';
import type { BrandAssets } from './brands/assets';

export const useBrandAssets = (): { assets: BrandAssets; meta: BrandMeta } => {
  const { brandId } = useBrand();
  return { assets: TEMPLATES[brandId].assets.assets, meta: BRAND_META[brandId] };
};
